import isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';

const urlWithParams = (url, params = {}) => (
  isEmpty(params) ? url : `${url}?${queryString.stringify(params)}`
);

export default urlWithParams;